export enum ExploreBanner {
  FILTER_PILL_TILE,
}
